import dayjs from "dayjs";
import { MediaTask } from "@coworker/types/lib/tasks/media";
import { TaskState } from "@coworker/apprestructured/src/tasks/enums/taskState";
import { TaskLinks } from "../types/taskLink";

export function duplicateTasksToParent(
  responseTasks: MediaTask[],
  taskLinks: TaskLinks
): MediaTask[] {
  // Filter taskLinks that have a parent with a media_id
  const childTaskLinks = taskLinks.filter(
    (taskLink) => !!taskLink.parentMediaId
  );

  // Duplicate tasks for taskLinks with a parent
  for (const childTaskLink of childTaskLinks) {
    const matchingTask = responseTasks.find(
      (rt) => rt.media_id === childTaskLink.mediaId
    );
    if (matchingTask) {
      responseTasks.push({
        ...matchingTask,
        media_id: childTaskLink.parentMediaId,
      });
    }
  }

  return responseTasks;
}

export function filterOngoingAndRecentTasks(tasks: MediaTask[]): MediaTask[] {
  const twentyThreeDaysAgo = dayjs().subtract(23, "days").toISOString();

  return tasks.filter(
    (task) =>
      task.state === TaskState.ASSIGNED ||
      task.state === TaskState.UNASSIGNED ||
      new Date(task.updated_at).toISOString() >= twentyThreeDaysAgo
  );
}
